import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper, Badge } from '@mui/material';
import {
  Home,
  CalendarMonth,
  Work,
  People,
  MoreHoriz,
  AccessTime,
  Map,
  Message
} from '@mui/icons-material';
import { useMessages } from '../../context/MessageContext';

const MANAGER_NAV = [
  { label: 'Home', icon: <Home />, path: '/' },
  { label: 'Schedule', icon: <CalendarMonth />, path: '/schedule' },
  { label: 'Jobs', icon: <Work />, path: '/jobs' },
  { label: 'Messages', icon: <Message />, path: '/messages', badgeKey: 'unreadCount' },
  { label: 'More', icon: <MoreHoriz />, path: '/more' }
];

const WORKER_NAV = [
  { label: 'Home', icon: <Home />, path: '/worker' },
  { label: 'Schedule', icon: <CalendarMonth />, path: '/worker/schedule' },
  { label: 'Messages', icon: <Message />, path: '/worker/messages', badgeKey: 'unreadCount' },
  { label: 'More', icon: <MoreHoriz />, path: '/worker/more' }
];

const BottomNav = ({ role = 'manager' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { unreadCount } = useMessages() || { unreadCount: 0 };
  
  const navItems = role === 'worker' ? WORKER_NAV : MANAGER_NAV;
  
  const getCurrentValue = () => {
    const currentPath = location.pathname;
    const index = navItems.findIndex(item => 
      currentPath === item.path || 
      (item.path !== '/' && currentPath.startsWith(item.path))
    );
    return index >= 0 ? index : 0;
  };

  return (
    <Paper 
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} 
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={(event, newValue) => {
          navigate(navItems[newValue].path);
        }}
        showLabels
      >
        {navItems.map((item, idx) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            onClick={() => navigate(item.path)}
            icon={
              item.badgeKey === 'unreadCount' ? (
                <Badge badgeContent={unreadCount} color="error">
                  {item.icon}
                </Badge>
              ) : item.icon
            }
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
